"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import {
  closeDialog,
  setDialog,
} from "@/components/app/dialogs/dialog-provider";
import { APP_ROUTES } from "@/utils/constants";
import { DIALOG, isDialogPathname } from "@/utils/dialog-routes";

import { isSearchDialogShortcut } from "./search-dialog-shortcut-listener-utils";

const SEARCH_DIALOG_PATH = `${APP_ROUTES.dialog}/${DIALOG.Search}`;

export const SearchDialogShortcutListener = () => {
  const pathname = usePathname();
  const isSearchDialogRoute = pathname === SEARCH_DIALOG_PATH;
  const isOtherDialogRoute =
    isDialogPathname(pathname) && pathname !== SEARCH_DIALOG_PATH;

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (!isSearchDialogShortcut(event)) {
        return;
      }

      if (isOtherDialogRoute) {
        return;
      }

      event.preventDefault();

      if (isSearchDialogRoute) {
        closeDialog();
        return;
      }

      setDialog(DIALOG.Search, {
        open: true,
      });
    };

    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [isOtherDialogRoute, isSearchDialogRoute]);

  return null;
};
